import { Box } from "@mui/material";
import DataGrid, {
  Column,
  FilterRow,
  HeaderFilter,
  Pager,
  Paging,
  SortByGroupSummaryInfo,
  Summary,
  TotalItem,
} from "devextreme-react/data-grid";
import Button from "devextreme-react/button";
import Toolbar, { Item } from "devextreme-react/toolbar";

import { useState, useRef, useEffect } from "react";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { DataGridConfig } from "../../../config";

import FilterBox from "./filter";
import {
  getVehicleCountBuildReportFun,
  getVehicleCountMarkReportFun,
  setFilter,
} from "../../../store/reducers/report";
import CustomDataGrid from "../../common/CustomDataGrid";

const VehicleCountMarkList = () => {
  const dispatch = useDispatch();
  const getVehicleCountMarkReportData = useSelector(
    (state) => state.report.vehicleCountMarkReportData
  );
  const filter = useSelector((state) => state.report.filter);

  const [formData, setFormData] = useState([]);
  const gridRef = useRef();

  const setFilters = (field, value) => {
    dispatch(setFilter({ ...filter, [field]: value }));
  };

  // Load API
  useEffect(() => {
    if (!gridRef.current) return;

    gridRef.current.instance.beginCustomLoading();

    if (getVehicleCountMarkReportData == null) {
      dispatch(getVehicleCountMarkReportFun(filter));
    } else {
      setFormData(getVehicleCountMarkReportData);
      gridRef.current.instance.endCustomLoading();
    }
  }, [getVehicleCountMarkReportData, filter, dispatch]);

  useEffect(() => {
    if (Object.keys(filter).length > 0) {
      dispatch(getVehicleCountMarkReportFun(filter));
    }
  }, [filter, dispatch]);

  // Data хоосон үед JSX алдаа захаас сэргийлнэ
  const hasData = formData && formData.length > 0;

  return (
    <>
      <Toolbar style={{ paddingBottom: "10px" }}>
        <Item location="before">
          <Box sx={{ ml: 2 }}>
            <FilterBox getFilters={setFilters} />
          </Box>
        </Item>
      </Toolbar>

      <Toolbar>
        <Item location="before">
          <Box sx={{ ml: 2 }}>
            <Button
              icon={"refresh"}
              onClick={() => {
                dispatch(getVehicleCountBuildReportFun(filter));
                gridRef.current.instance.refresh();
              }}
              type={"normal"}
              text="Сэргээх"
            />
          </Box>
        </Item>

        <Item location="after">
          <Box>
            <Button
              onClick={() => {
                gridRef.current.instance.exportToExcel();
              }}
            >
              <Box sx={{ background: "#fff", p: 0.5 }}>
                <img src="/assets/excel.png" alt="" className="dx-icon" />
              </Box>
            </Button>
          </Box>
        </Item>
      </Toolbar>

      <DataGrid
        ref={gridRef}
        {...DataGridConfig}
        remoteOperations={false}
        dataSource={formData}
        id="gridContainer"
        wordWrapEnabled={false}
        height={600}
      >
        <Paging defaultPageSize={100} />
        <Pager
          visible={true}
          showPageSizeSelector={true}
          allowedPageSizes={[20, 50, 100, 200, 500, 1000]}
          showNavigationButtons={true}
          showInfo={true}
        />

        <FilterRow visible={true} applyFilter={"full"} />
        <HeaderFilter visible={true} />

        {/* FIXED COLUMNS */}
        <Column dataField="id" caption="№" width={80} />
        <Column dataField="company_name" caption="Компани нэр" width={250} />
        <Column dataField="total_vehicle" caption="Нийт тоо" width={120} />

        {/* Dynamic columns */}
        {hasData &&
          Object.keys(formData[0])
            .filter(
              (col) => !["id", "company_name", "total_vehicle"].includes(col)
            )
            .map((col) => <Column key={col} dataField={col} caption={col} />)}

        {/* SUMMARY */}
        {hasData && (
          <Summary skipEmptyValues={true}>
            {/* Нэрний дор "Нийт дүн" гэж гаргана */}
            <TotalItem
              column="company_name"
              summaryType="sum"
              customizeText={() => "Нийт дүн"}
            />

            {/* Нийт тоо */}
            <TotalItem
              column="total_vehicle"
              summaryType="sum"
              displayFormat="{0}"
            />

            {/* Бусад бүх багана */}
            {Object.keys(formData[0])
              .filter(
                (col) => !["id", "company_name", "total_vehicle"].includes(col)
              )
              .map((col) => (
                <TotalItem
                  key={col}
                  column={col}
                  summaryType="sum"
                  displayFormat="{0}"
                />
              ))}
          </Summary>
        )}

        <SortByGroupSummaryInfo summaryItem={0} />
      </DataGrid>
    </>
  );
};

export default VehicleCountMarkList;
